import React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '../icon-prop-types';

export const WinnerArrowIcon = ({ fill = 'green', className }: IconProps & { className?: string }) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            data-testid="winner-arrow-icon"
            width="8"
            height="15"
            viewBox="0 0 8 15"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className={className}
        >
            <g className={fillStyles}>
                <path d="m0 0 8 6.667-8 6.666V0z" />
            </g>
        </svg>
    );
};
